// Common candidate job roles — sourced from the KGS candidates_template.csv
// baseline plus additional common titles. Candidates pick "Other" to type a
// custom role.
export const ROLES = [
  "Data Analyst",
  "Data Scientist",
  "Data Engineer",
  "Business Analyst",
  "Product Manager",
  "Associate Product Manager",
  "Technical Product Manager",
  "Product Marketing Manager",
  "Project Manager",
  "Assistant Project Manager",
  "Program Manager",
  "Project Engineer",
  "Project Control Engineer",
  "Assistant Project Engineer",
  "DevOps Engineer",
  "Cloud Engineer",
  "Site Reliability Engineer",
  "Software Developer",
  "Software Engineer",
  "Senior Software Engineer",
  "Full Stack Developer",
  "Full Stack Engineer",
  "Front End Developer",
  "Back End Developer",
  ".NET Full Stack Engineer",
  "Java Full Stack Developer",
  "Software Development Engineer",
  "AI Engineer",
  "AI/ML Engineer",
  "GenAI Engineer",
  "ML Engineer",
  "Machine Learning Engineer",
  "Game Developer",
  "Mobile Developer",
  "iOS Developer",
  "Android Developer",
  "UI Designer",
  "UX Designer",
  "Graphic Designer",
  "SOC Analyst",
  "Cybersecurity Analyst",
  "Security Engineer",
  "Network Engineer",
  "IT Support Specialist",
  "IT / Desktop Support Engineer",
  "System Administrator",
  "Cloud Solutions Architect",
  "Database Administrator",
  "MEP Engineer",
  "Mechanical Engineer",
  "Manufacturing Engineer",
  "Quality Engineer",
  "Industrial Engineer",
  "Automotive Engineer",
  "Solar PV Engineer",
  "Product Engineer",
  "Design Verification Engineer",
  "Design For Test Engineer",
  "Embedded Engineer",
  "RF Engineer",
  "Transportation Engineer",
  "VDC Engineer",
  "Biomedical Engineer",
  "Paint Process Engineer",
  "Bioinformatician",
  "Research Associate",
  "Regulatory Affairs Associate",
  "Clinical Research Assistant",
  "Financial Analyst",
  "FP&A Analyst",
  "Portfolio Analyst",
  "Actuarial Analyst",
  "Senior Accountant / Accounting Manager",
  "Talent Acquisition Coordinator",
  "HR Business Partner",
  "Recruiter",
  "Digital Marketing Analyst",
  "Marketing Manager",
  "Operations / Supply Chain Analyst",
  "Procurement Specialist",
  "Workforce Management Analyst",
  "Salesforce Consultant",
  "Salesforce Administrator",
  "Salesforce Developer",
  "Paralegal",
  "Compliance Analyst",
  "Other",
];

export const ROLE_OTHER = "Other";
